import type { BatchPreviewTableColumn } from "../batch-preview-table";
import type { InterventionLite } from "@/entities/intervention";

import { useTranslation } from "react-i18next";

import { useGetInterventions } from "@/entities/interventions";
import InterventionBreadcrumb from "@/modules/intervention/intervention-breadcrumb";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";
import { sortTexts } from "@/utilities/string";

import {
  useBatchPreviewTableColumnName,
  useBatchPreviewTableColumnState,
} from "../batch-preview-table";
import { BATCH_PREVIEW_PAGE_SIZE } from "../batch-preview.constant";
import { useBatchPreviewIdsParam } from "../batch-preview.hook";

export const useBatchPreviewInterventionAssignPage = () => {
  const { t } = useTranslation();
  const { idsParam, ids } = useBatchPreviewIdsParam();

  const { interventions, isLoading } = useGetInterventions({
    enabled: ids.length > 0,
    params: {
      "filter[id]": idsParam,
      "page[size]": BATCH_PREVIEW_PAGE_SIZE,
    },
  });

  const columns: BatchPreviewTableColumn<InterventionLite>[] = [
    useBatchPreviewTableColumnName("intervention"),
    {
      key: "asset",
      dataIndex: "asset.name",
      title: t("global:asset"),
      render: (_asset, intervention) => (
        <InterventionBreadcrumb
          intervention={intervention}
          include={["asset"]}
          hideIcon
          ellipsis
          compact
        />
      ),
      ...TABLE_FILTER_TEXT,
      onFilter: (value, intervention) =>
        intervention.asset.name.includes(value as string),
      sorter: (a, b) => sortTexts(a.asset.name, b.asset.name),
    },
    useBatchPreviewTableColumnState("intervention", interventions),
  ];

  return {
    interventions,
    loading: isLoading,
    columns,
  };
};
